import store from '@/store'

export default [
  {
    path: '/service-subscriptions',
    name: 'service-subscription',
    meta: { requiresAuth: true },
    component: () => import('@/pages/service-subscription/index.vue')
  }
]
